/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IAddModuleSlot } from '@msdyn365-commerce/core-internal';
import * as React from 'react';

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ICategoryPageContainerData } from './category-page-container.data';
import { ICategoryPageContainerProps } from './category-page-container.props.autogenerated';

export interface ICategoryPageContainerViewProps extends ICategoryPageContainerProps<ICategoryPageContainerData> {
    categoryContainer: IAddModuleSlot;
    title: string;
    slogan: string;
    mainHeaderCustomClass: string;
    pageBorderCustomClass: string;
    contentCustomClass: string;
    sloganCustomClass: string;
    links: Msdyn365.ILinksData;
}

/**
 *
 * CategoryPageContainer component
 * @extends {React.PureComponent<ICategoryPageContainerProps<ICategoryPageContainerData>>}
 */
class CategoryPageContainer extends React.PureComponent<ICategoryPageContainerProps<ICategoryPageContainerData>> {
    public render(): JSX.Element | null {
        const { slots, config } = this.props;
        const CategoryPageContainerViewProps = {
            ...this.props,
            categoryContainer: slots,
            title: config.title,
            slogan: config.slogan,
            mainHeaderCustomClass: config.mainHeaderCustomClass,
            pageBorderCustomClass: config.pageBorderCustomClass,
            contentCustomClass: config.ContentCustomClass,
            sloganCustomClass: config.sloganCustomClass,
            links: config.links
        }
        return this.props.renderView(CategoryPageContainerViewProps);
    }
}

export default CategoryPageContainer;
